/**
 * Pages
 */

export * from './pages/PriceList/PriceList';
